module.exports = __webpack_public_path__ + "img/QuickPockets.de3a7bb4.png";